import React from "react";

const FlexCard = ({
  className,
  flexOuterClass,
  data,
  title,
  verifiedIconsFor,
  hasFileId = false,
  hasPdfFile = false,
  hasOfficeId = false,
  fileIdKey,
  officeIdKey,
  pdfIdKey,
  colspan_key,
  colspan_value,
  showResponseActions,
  response,
  responseTitle,
  handleResponseAccept,
  handleResponseReject,
  editable = false,
  onEdit = (v) => v,
}) => {
  if (data && Object.keys(data).length > 0) {
    // console.log({ data });
  }
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;

  const convertBlobToPdf = (data) => {
    return (
      window.URL.createObjectURL(
        new Blob([data], { type: "application/pdf" })
      ) || ""
    );
  };
  return (
    <div className={`flex_card_outer ${flexOuterClass}`}>
      {editable && (
        <button
          type="button"
          className="btn edit_btn"
          onClick={(e) => onEdit(e)}
        >
          <i className="fa fa-pencil"></i>
        </button>
      )}
      <div className={`flex_card row ${className || ""}`}>
        {title && <h4 className="title">{title}</h4>}
        {data &&
          Object.entries(Object.except(data, ["soa", "noc"]))
            .filter((innerArr) => innerArr[0] !== "fileId")
            .map(([key, value], i) => (
              <div
                key={key}
                className={`card-item ${
                  i === 1 ? colspan_value || "col-2" : colspan_key || "col-2"
                }`}
              >
                <div className="card-key">{key?.spaceCase().toTitleCase()}</div>
                <div className="card-value">
                  {hasPdfFile && pdfIdKey === key ? (
                    <>
                      <a
                        // href={`${data["loan_agreement"] || ""}`}
                        href={`${BASE_URL}${data["loan_agreement"] || ""}`}
                        target="_blank"
                        download
                        className="download_link fw-normal ms-2"
                      >
                        Download
                      </a>
                    </>
                  ) : hasFileId && fileIdKey === key ? (
                    <>
                      {value || "-"}
                      <a
                        href={`${BASE_URL}${data["fileId"] || ""}`}
                        className="download_link fw-normal ms-2"
                      >
                        Download
                      </a>
                    </>
                  ) : hasOfficeId && officeIdKey === key ? (
                    <>
                      <a
                        href={`${BASE_URL}${data[officeIdKey] || ""}`}
                        className="download_link fw-normal ms-2"
                      >
                        Download
                      </a>
                    </>
                  ) : (
                    <>{value === 0 ? 0 : value || "-"}</>
                  )}
                  {verifiedIconsFor && verifiedIconsFor.includes(key) ? (
                    <i className="fa fa-circle-check text-green ms-2"></i>
                  ) : null}
                </div>
              </div>
            ))}
        {/* BLOB DATA */}
        {data && Object.keys(data).includes("soa") && (
          <div className={`card-item col-2`}>
            <div className="card-key">SOA</div>
            <div className="card-value">
              {data?.soa ? (
                <a
                  href={convertBlobToPdf(data?.soa)}
                  className="download_link fw-normal ms-2"
                  download={`soa-${
                    data?.loan_Id || data?.loan_application_no
                  }.pdf`}
                >
                  Download
                </a>
              ) : (
                "-"
              )}
            </div>
          </div>
        )}
        {data && Object.keys(data).includes("noc") && (
          <div className={`card-item col-2`}>
            <div className="card-key">NOC</div>
            <div className="card-value">
              {data?.noc ? (
                <a
                  href={convertBlobToPdf(data?.noc)}
                  className="download_link fw-normal ms-2"
                  download={`noc-${
                    data?.loan_Id || data?.loan_application_no
                  }.pdf`}
                >
                  Download
                </a>
              ) : (
                "-"
              )}
            </div>
          </div>
        )}
        {/* END BLOB DATA */}
        {response && (
          <div>
            {responseTitle && <h4 className="title">{responseTitle}</h4>}
            <div className="docs_card_container row g-0">
              {response?.map((item, i) => {
                return (
                  <div className="col-6 col-sm-4 col-md-6 col-lg-2">
                    <div className="docs_card" key={i}>
                      <img
                        src={imagepaths.docsCardRedIcon}
                        alt="docsCardRedIcon"
                      />
                      <h2 className="title">PAN Card Front</h2>
                      {item?.panFileId ? (
                        <a
                          href={`${BASE_URL}${item?.panFileId}`}
                          className="text-primary"
                        >
                          Download
                        </a>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                );
              })}
              {showResponseActions && (
                <div className="nav_container mt-5">
                  <button
                    type="button"
                    className="btn btn-primary-lite me-3"
                    onClick={(...args) =>
                      handleResponseReject(...args, "reject")
                    }
                  >
                    Reject
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(...args) =>
                      handleResponseAccept(...args, "accept")
                    }
                  >
                    Accept
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FlexCard;
